import { IController } from 'angular';
import { IStateService } from 'angular-ui-router';
import { SpinnerModal } from './../../../shared/modals/status-spinner/status-spinner.service';

export class NvClusterCtrl implements IController {
  static $inject: string[] = ['currentUser', 'NavService', 'SpinnerModal', '$state'];

  public clusterSchools;
  public placeholder;

  constructor(
    private currentUser,
    private NavService,
    private SpinnerModal: SpinnerModal,
    private $state: IStateService,
  ) {}

  $onInit() {
    this.clusterSchools = this.currentUser._role_clusterSchools;
    this.NavService.closeNav('left');
    this.SpinnerModal.deactivateSpinner();
    this.placeholder = 'Search for school name or ID';
  }

  goBack(): void {
    const { lastView, stateParams } = this.$state.params;
    const route = lastView ? lastView : 'main.network.dashboard';
    this.$state.go(route, stateParams);
  }
}
